import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

export const SCACColumns = (handleEdit, handleDelete) => {
    return [
        {
            field: 'scac_code',
            headerName: 'SCAC',
            width: 200,
            sortable: true
        },
        {
            field: 'scac_name',
            headerName: 'SCAC Name',
            width: 250,
            sortable: true
        },
        {
            field: 'description',
            headerName: 'Type',
            width: 250,
            sortable: true,
            sortField: 'scac_type_id'
        },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 250,
            sortable: true
        },
        {
            field: 'url',
            headerName: 'URL',
            width: 250,
            sortable: true
        },
        {
            field: 'edit',
            headerName: 'Actions',
            width: 140,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </>
            )
        }
    ];
};
